// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2682":"e08bad3d","2859":"52aa3f42","3290":"ef38fd1a","4215":"25ebebac","4955":"30c6d166"}[chunkId] + ".chunk.css";
};